import axiosClient from "../axios-client";
import { getReportSuccess } from "../reducers/supportReducer";
import { toastMessage } from "../toaster/toaster";
import { changeLoaderStatus } from "./loaderAction";


// ===============================================================================
// =================================== GET API ===================================
// ===============================================================================

export const getReports = async (report_id, dispatch) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/report/details/${report_id}`)
        .then((res) => {
            dispatch(getReportSuccess(res?.data || {}))
            return res?.data
        })
        .catch((error) => {
            toastMessage("Reports not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const getAllReports = async (dispatch, data) => {
    changeLoaderStatus(dispatch, true);
    const queryString = new URLSearchParams(data).toString();
    const url = `/report/list?${queryString}`;
    return axiosClient
        .get(url)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Reports not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const approveReport = async (dispatch, report_id) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/report/approve/${report_id}`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Report not approved successfully", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


// ===============================================================================
// ================================== POST API ===================================
// ===============================================================================

export const rejectReport = async (dispatch, report_id, rejection_msg) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .post(`/report/reject/${report_id}`, rejection_msg)
        .then((res) => {
            toastMessage("Report rejected successfully", "success")
            return res?.data
        })
        .catch((error) => {
            toastMessage("Report not rejected successfully", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};
